import { render, staticRenderFns } from "./reservationNumber.vue?vue&type=template&id=08819918&scoped=true&"
import script from "./reservationNumber.vue?vue&type=script&lang=ts&"
export * from "./reservationNumber.vue?vue&type=script&lang=ts&"
import style0 from "./reservationNumber.vue?vue&type=style&index=0&id=08819918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08819918",
  null
  
)

export default component.exports